// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"65335592","192":"787b83a8","401":"a9507be4","733":"6bbc8890","747":"a85a4286"}[chunkId] + ".chunk.js";
};